module.exports = __webpack_public_path__ + "static/media/atom.01295875.svg";